import * as React from 'react';

import {
  CommunicationActionLink,
  CommunicationLayout,
  CommunicationErrorIllustration,
} from '../../../../components/Communication';
import { IBasePaymentCommunicationProps } from '../../types';

export interface IPaymentErrorCommunicationProps extends IBasePaymentCommunicationProps {
  onAction: () => void;
  href: string;
}

export const PaymentError: React.FC<IPaymentErrorCommunicationProps> = ({ onAction, href, testId }) => {
  return (
    <CommunicationLayout
      image={<CommunicationErrorIllustration />}
      title={'Ой, что-то пошло не так'}
      testId={testId}
      message="Оплата отчёта не прошла. Мы разберёмся, почему так вышло. К сожалению, чтобы заказать отчёт нужно будет заново ответить на вопросы анкеты."
      action={
        <CommunicationActionLink href={href} onClick={onAction}>
          Заказать отчёт заново
        </CommunicationActionLink>
      }
    />
  );
};

PaymentError.displayName = 'PaymentError';
